export default {
    identify:'IDENTIFY',
    identifySuccess:'IDENTIFY_SUCCESS',
    reset:'RESET'
}